const emailConstants = {
  SEND_CONTACT_EMAIL_REQUEST: 'SEND_CONTACT_EMAIL_REQUEST',
  SEND_CONTACT_EMAIL_SUCCESS: 'SEND_CONTACT_EMAIL_SUCCESS',
  SEND_CONTACT_EMAIL_FAILURE: 'SEND_CONTACT_EMAIL_FAILURE',
};

export default emailConstants;
